import { useAuth, useSnippets, useToday } from '@/hooks'
import { SnippetForm, SnippetList } from '@/components/snippets'
import { formatDate } from '@/lib/date'

export const Today = () => {
  const { user } = useAuth()
  const today = useToday()
  const { snippets, loading, error, create, update, remove } = useSnippets({
    userId: user!.uid,
    date: today,
  })

  const handleCreate = async (content: string) => {
    await create({ content, date: today })
  }

  const handleUpdate = async (id: string, content: string) => {
    await update(id, { content })
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Today</h1>
        <p className="text-gray-600">{formatDate(today)}</p>
      </div>

      <div className="mb-8">
        <div className="card">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">
            Add a Snippet
          </h2>
          <SnippetForm onSubmit={handleCreate} />
        </div>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{error.message}</p>
        </div>
      )}

      {loading ? (
        <div className="text-center py-8 text-gray-600">
          Loading snippets...
        </div>
      ) : (
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-4">
            Today's Snippets ({snippets.length})
          </h2>
          <SnippetList
            snippets={snippets}
            onUpdate={handleUpdate}
            onDelete={remove}
            emptyMessage="No snippets for today. Add your first one above!"
          />
        </div>
      )}
    </div>
  )
}
